import React from "react";
import SingleInstrumentSectionBTK from "./SingleInstrumentSectionBTK";
import InstrumentSelectorBTK from "./InstrumentSelectorBTK";

function InstrumentBTKSection(props) {

    function update(event) {
    }

    return (
        <div className="mb-3">
            <label className="form-label">Prístroje</label>
            {props.data.Pristroje.map((item, ndx) => (
                <SingleInstrumentSectionBTK selectPart={props.selectPart}
                                            deletePart={props.deletePart}
                                            updatePart={props.updatePart}
                                            selectWork={props.selectWork}
                                            deleteWork={props.deleteWork}
                                            updateWork={props.updateWork}
                                            deleteInstrument={props.deleteInstrument}
                                            selectInstrument={props.selectInstrument}
                                            selectBTKResult={props.selectBTKResult}
                                            data={props.data}
                                            update={props.update}
                                            ndx={ndx}
                                            item={item}
                                            emptyInstrument={false}
                                            key={ndx}/>
            ))}
            <InstrumentSelectorBTK value=""
                                   selectInstrument={props.selectInstrument}
                                   optionDisplay="SNR"
                                   ndx={props.ndx}
                                   index={null}
                                   stateResetOnChange={true}
                                   data={props.data}
                                   empty={true}
            />
        </div>
    )
}

export default InstrumentBTKSection
